<template>
  <div>
    <nav-breadcrumb :menu="[{label: '质押申请列表'}]"/>
    <el-row>
      <el-col class="grid-content bg-purple">
        <el-row>
          <el-tabs v-model="filterOptions.applicationStatus">
            <el-tab-pane label="待审核" name="Pending Approval" />
            <el-tab-pane label="已审核" name="Approved, Rejected" />
          </el-tabs>
          <data-table
            :tableData="pledgeApplyingListData"
            :columns="pledgeApplyingListColumns"
            :filters.sync="filters"
            :pageSize.sync="pageSize"
            :page.sync="page"
            class="xzmLR10"
          ></data-table>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import xhr from '../../../utils/xhr'
  import DataTable from '../../../components/DataTable'
  import moment from 'moment'
  import Status2CN from "../../../filters/Status2CN";
  import {xmlBuildQuery} from "../../../filters/CommonActions";

  export default {
    name: 'ServerAdminPledgeApplyingList',
    data() {
      return {
        filterOptions: {
          applicationStatus: 'Pending Approval'
        },
        page: 1,
        pageSize: 10,
        pledgeApplyingListData: {},
        filters: {
          form: {
            pl__applicationNo: '',
            u__customerName: '',
            ct__contractNo: '',
            pl__applicationDate: [],
            ct__productName: ''
          },
          columns: [
            {
              label: '质押批次号',
              component: 'el-input',
              field: 'pl__applicationNo'
            },
            {
              label: '客户名称',
              component: 'el-input',
              field: 'u__customerName'
            },
            {
              label: '合同编号',
              component: 'el-input',
              field: 'ct__contractNo'
            },
            {
              label: '质押日期',
              component: 'date-range-picker',
              field: 'pl__applicationDate'
            },
            {
              label: '融资产品',
              component: 'el-input',
              field: 'ct__productName'
            }
          ],
          onSubmit:()=>{
            this.page = 1
            this.getCustomerApplyingPledgeList()
          }
        }
      }
    },
    computed : {
      pledgeApplyingListColumns: function() {
        return [
          {
            name: '质押批次号',
            field: 'pl__applicationNo'
          },
          {
            name: '客户名称',
            field: 'u__customerName'
          },
          {
            name: '供应链',
            field: 'ct__debtorName'
          },
          {
            name: '质押日期',
            field: 'pl__applicationDate',
            formatter: function (r,c,v) {
              return moment(v).format('YYYY-MM-DD')
            }
          },
          {
            name: '合同编号',
            field: 'ct__contractNo',
          },
          {
            name: '融资产品',
            field: 'ct__productName',
          },
          {
            name: '本次质押单据数量',
            field: 'pl__invoiceCount',
          },
          {
            name: '本次质押单据总额',
            field: 'pl__totalAmount',
          },
          {
            name: '申请状态',
            field: 'pl__applicationStatus',
            formatter: function (r,c,v) {
              return Status2CN(v)
            }
          },
          {
            name: '申请日期',
            field: 'pl__applicationDate',
            formatter: function (r,c,v) {
              return moment(v).format('YYYY-MM-DD')
            }
          },
          {
            name: '操作',
            opts:
              [
                {
                  class: 'el-icon-success',
                  name: '审核',
                  conditions:(row)=>{
                    return row.pl__applicationStatus == 'Pending Approval'
                  },
                  clickHandler: (index, row)=>{
                    this.viewDetail(index, row)
                  }
                },
                {
                  class: 'el-icon-info',
                  name: '查看',
                  clickHandler: (index, row)=>{
                    this.viewDetail(index, row)
                  }
                },
              ]

          }
        ]
      },
      filterParams: {
        get: function() {
          return {
            pageSize: this.pageSize,
            pageOffset: (this.page - 1) * this.pageSize,
            'xlist.search.pl.applicationStatus': this.filterOptions.applicationStatus,
            'xlist.search.pl.applicationStatus.op': 'in',
            'xlist.sort.dataField': 'pl.applicationDate',
            'xlist.sort.order': 'desc'
          }
        },
        set:function (newVal) {

        }
      }
    },
    watch: {
      filterParams: function () {
        this.getCustomerApplyingPledgeList()
      }
    },
    mounted() {
      this.getCustomerApplyingPledgeList()
    },
    components: {
      DataTable
    },
    methods: {
      getCustomerApplyingPledgeList: function () {
        xhr.getCustomerApplyingPledgeList(
          Object.assign({}, this.filterParams, xmlBuildQuery(this.filters) ),
          res=> {
          try {
            this.pledgeApplyingListData = res.data
          }catch(e){

          }
        })

      },
      viewDetail: function (index, row) {
        try {
          this.$router.push({path: 'ApplyingDetail?pl.applicationId='+ row.pl__applicationId})
        }
        catch (e) {

        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/ServiceAdmin/PledgeApplyingList.vue